// extracted by mini-css-extract-plugin
export default {"form":"file-form_form__Ccvnk","button":"file-form_button__NBEEP"};